import { Injectable, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColleagueHandoffFacade {
  private readonly _redirectUrl = signal<string | null>(null);

  readonly redirectUrl = computed(() => this._redirectUrl());

  setRedirectUrl(url: string | null): void {
    this._redirectUrl.set(url);
  }
}
